import React from 'react';
import { Navigate, Route, Routes, useParams, useLocation } from 'react-router-dom';
import { Section } from 'components/styledComponents';
import { useTranslation } from 'hooks';
import Opportunities from './Opportunities';
import Placements from './Placements';
import { Container, Link, LinkContainer } from './style';

function ManagementPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const location = useLocation();

  const basePath = id ? `/management/${id}` : '/management';

  return (
    <Section fullSize>
      <Container>
        <LinkContainer>
          <Link
            to={`${basePath}/opportunities`}
            className={location.pathname.includes('opportunities') ? 'active' : ''}
          >
            {t('title.opportunities')}
          </Link>
          <Link
            to={`${basePath}/placements`}
            className={location.pathname.includes('placements') ? 'active' : ''}
          >
            {t('title.placements')}
          </Link>
        </LinkContainer>
        <Routes>
          <Route path="opportunities" element={<Opportunities />} />
          <Route path="placements" element={<Placements />} />
          <Route path="*" element={<Navigate to={`${basePath}/opportunities`} replace />} />
        </Routes>
      </Container>
    </Section>
  );
}

ManagementPage.propTypes = {};

export default ManagementPage;
